import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useState } from 'react'
import Login from './Login'
import SurveyComponent from './SurveyComponent'
import Agree from './Agree'
import BarLoader from 'react-spinners/BarLoader'
// import { AuthContext } from './AuthContext'

function App() {
  const [currentUser, setCurrentUser] = useState(null)
  const [ac, setAc] = useState(null)
  const [tk, setTk] = useState(null)
  const [convertedSurvey, setconvertedSurvey] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])

  // let { pid } = useParams()
  // pid = 'P' + pid.split('p')[1]
  // 特殊設定
  const { pathname } = useLocation()
  const pid = 'P' + pathname.toLowerCase().split('/p')[1]

  // pid = 'P' + pid.split('/p')[1]
  // const pid = 'P231206105643'
  // 隨機一份問卷
  // const pidObj = {
  //   0: 'P230919184319',
  //   1: 'P230815121716',
  //   2: 'P230815121714',
  // }

  // const [randomPid, setrandomPid] = useState('')
  // useEffect(() => {
  //   const ord = Math.floor(Math.random() * 3)
  //   setrandomPid(pidObj[ord])
  // }, [])
  // console.log('randomPid', randomPid)

  // BarLoader
  const actualInnerWidth = document.body.clientWidth - 20

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'fixed', zIndex: '1021' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />
      {/* <AuthContext.Provider value={{ setIsLoading, isLoading }}> */}
      {/* <Routes> */}
      {/* {convertedSurvey ? (
        <SurveyComponent
          setIsLoading={setIsLoading}
          pid={pid}
          ac={ac}
          tk={tk}
          convertedSurvey={convertedSurvey}
          imagesReadingTime={imagesReadingTime}
          setImagesReadingTime={setImagesReadingTime}
        />
      ) : ( */}
      <Agree
        setIsLoading={setIsLoading}
        pid={pid}
        setAc={setAc}
        setTk={setTk}
        ac={ac}
        tk={tk}
        setconvertedSurvey={setconvertedSurvey}
        imagesReadingTime={imagesReadingTime}
        setImagesReadingTime={setImagesReadingTime}
      />
      {/* )} */}
      {/* {!currentUser && (
            <Route
              path="/"
              element={
                <Login
                  setIsLoading={setIsLoading}
                  setCurrentUser={setCurrentUser}
                  setAc={setAc}
                  setTk={setTk}
                />
              }
            />
          )}
          {currentUser && !convertedSurvey && (
            <Route
              path="/"
              element={
                <Agree
                  setIsLoading={setIsLoading}
                  pid={pid}
                  ac={ac}
                  tk={tk}
                  setconvertedSurvey={setconvertedSurvey}
                  imagesReadingTime={imagesReadingTime}
                />
              }
            />
          )}

          {convertedSurvey && (
            <Route
              path="/"
              element={
                <SurveyComponent
                  setIsLoading={setIsLoading}
                  pid={pid}
                  ac={ac}
                  tk={tk}
                  convertedSurvey={convertedSurvey}
                  imagesReadingTime={imagesReadingTime}
                  setImagesReadingTime={setImagesReadingTime}
                />
              }
            />
          )} */}
      {/* </Routes> */}
      {/* </AuthContext.Provider> */}
    </>
  )
}

export default App
